if (!window.Eurus.loadedScript.has('product-cart.js')) {
  window.Eurus.loadedScript.add('product-cart.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId,
      ) => ({
        loading: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          originalAtcBtn.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        async hashProperties(formData) {
          let result = [];
          for (let [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match) {
              if (value instanceof File) {
                result.push(`${value.name}:${value.size}:${value.type}`);
              } else {
                result.push(value);
              }
            }
          }
          result.push(formData.get('id'));
          result.sort();

          let data = result.join('|');

          const encoder = new TextEncoder();
          const dataBuffer = encoder.encode(data);

          const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

          return hashHex;
        },
        async addToCart(e, required, quickView, sticky) {
          this.loading = true;         
          e.preventDefault();

          setTimeout(async () => {
            if (required) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                      });
                      scrollStatus = true;
                    }    
                  } else {
                    input.classList.remove("required-picker");
                  }                
                });              
              }
              if (this.stopAction) {
                setTimeout (() => {
                  this.loading = false;
                }, 500);
                return true;
              }
            }
            const cartHelper = Alpine.store('xCartHelper');
            const shouldWaitForEstimate = !!(window.Eurus && window.Eurus.enableEstimateShipping) && !!(cartHelper && cartHelper.needUpdateEstimated);
            if (shouldWaitForEstimate) {
              await cartHelper.waitForEstimateUpdate();
            }
            window.updatingEstimate = shouldWaitForEstimate;

            const isCartNotiEnabled = !!(Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable);
            const miniCart = Alpine.store('xMiniCart');
            const canOpenMiniCartFlow = !isCartNotiEnabled && miniCart;
            const isBundleAddCandidate = (quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'));
            const useFastMiniCartAdd = !!(canOpenMiniCartFlow && !isBundleAddCandidate);

            const allSectionsToRender = Alpine.store('xCartHelper')
              .getSectionsToRender()
              .filter((section) => section && section.id && section.selector)
              .filter((section) => isCartNotiEnabled || (section.id !== 'quick-order-list' && section.selector !== '#QuickOrderList' && section.selector !== '#QuickOrderListSummary'));
            const insuranceFeatureEnabled = !!(window.Eurus && window.Eurus.enableShippingInsurance);
            const giftWrapFeatureEnabled = !!(wrappringVariantId && this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_id);
            const engravingFeatureEnabled = !!(engravingVariantId && this.$refs.engraving_text);
            const hasAnyOptionalAtcFeature = insuranceFeatureEnabled || giftWrapFeatureEnabled || engravingFeatureEnabled;

            if (engravingFeatureEnabled) {
              if (this.$refs.engraving_text.value.trim()) {
                if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
              } else {
                if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
              }
            }

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            let formData = new FormData(this.$refs.product_form);
            var edt_element = productForm ? productForm.querySelector(`.hidden.cart-edt-properties-${formData.get('product-id')}`) : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            formData = new FormData(this.$refs.product_form);

            if (giftWrapFeatureEnabled && this.$refs.gift_wrapping_checkbox.checked) {
              await this.hashProperties(formData).then(hashHex => {
                this.$refs.gift_wrapping_id.value = hashHex;
                formData = new FormData(this.$refs.product_form);
              });
            }

            if (!useFastMiniCartAdd && allSectionsToRender.length > 0) {
              formData.append(
                'sections',
                allSectionsToRender.map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
            }
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
              if (value !== '') {
                newFormData.append(key, value);
              }
            }
            await fetch(`${Eurus.cart_add_url}`, {
              method:'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: newFormData
            }).then(reponse => {
              return reponse.json();
            }).then(async (response) => {
              if (response.status == '422') {
                if (typeof response.errors == 'object') {
                  this.error_message_wrapper = response.errors;
                  document.querySelector('.recipient-error-message').classList.remove('hidden');
                } else {
                  this.errorMessage = true;
                  setTimeout(() => {
                    this.errorMessage = false;
                  }, 3000);
                  if(this.$refs.error_message){
                    this.$refs.error_message.textContent = response.description;
                  }
                  if(this.$refs.error_message_mobile){
                    this.$refs.error_message_mobile.textContent = response.description;
                  }
                }
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                }
              } else {  
                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(response); 
                }
                let insuranceCookieMatch = insuranceFeatureEnabled ? document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)') : null;
                const addAdditionalItemsInBackground = (additionalOptionData, allSectionsToRender) => {
                  if (!hasAnyOptionalAtcFeature) return;
                  Promise.resolve()
                    .then(() => Alpine.store('xCartHelper').getManagedFreeGiftItemsToAdd())
                    .then((managedFreeGiftItems) => {
                      additionalOptionData.items.push(...(managedFreeGiftItems || []));
                      if (additionalOptionData.items.length === 0) return;

                      return window.fetch('/cart/add.js', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                          'Content-Type': 'application/json',
                          'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: JSON.stringify(additionalOptionData),
                      });
                    })
                    .then((res) => {
                      if (!res) return null;
                      return res.json();
                    })
                    .then((additionalResponse) => {
                      if (!additionalResponse) return;
                      const isDrawerOpen = Alpine.store('xMiniCart') && Alpine.store('xMiniCart').open;
                      allSectionsToRender.forEach((section => {
                        if (isDrawerOpen && section.selector === '#CartDrawer') {
                          if (additionalResponse.sections && additionalResponse.sections[section.id] && Alpine.store('xCartHelper')) {
                            Alpine.store('xCartHelper').refreshOpenCartDrawerDiscounts(additionalResponse.sections[section.id]);
                          }
                          return;
                        }
                        const sectionElement = document.querySelector(section.selector);
                        if (sectionElement && additionalResponse.sections && additionalResponse.sections[section.id]) {
                          sectionElement.innerHTML = getSectionInnerHTML(additionalResponse.sections[section.id], section.selector);
                        }
                      }));
                      Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
                      document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                    })
                    .catch((error) => {
                      console.error('Error:', error);
                    });
                };
                const shouldAddGiftWrapItem = giftWrapFeatureEnabled && this.$refs.gift_wrapping_checkbox.checked && response.properties && response.properties['_gift_wrapping_id'];
                const shouldAddEngravingItem = engravingFeatureEnabled && this.$refs.engraving_text.value.trim();
                const shouldAddInsuranceItem = insuranceFeatureEnabled && this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!insuranceCookieMatch || insuranceCookieMatch[2].trim() === '');
                if (shouldAddGiftWrapItem || shouldAddEngravingItem || shouldAddInsuranceItem) {
                  let additionalOptionData = {
                    items: [],
                    sections: allSectionsToRender.map((section) => section.id),
                    sections_url: window.location.pathname
                  };
                  if (shouldAddGiftWrapItem) {
                    additionalOptionData.items.push(
                      {
                        id: wrappringVariantId,
                        quantity: 1,
                        properties: {
                          "For": response.title,
                          "_key_link": response.properties['_gift_wrapping_id']
                        }
                      }
                    );
                  }
                  if (shouldAddEngravingItem) {
                    additionalOptionData.items.push(
                      {
                        id: engravingVariantId,
                        quantity: 1
                      }
                    );
                  }
                  if (shouldAddInsuranceItem) {
                    additionalOptionData.items.push(
                      {
                        id: this.insuranceVariantId,
                        quantity: 1
                      }
                    );
                  }

                  document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                  this.error_message_wrapper = {};

                  if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                    Alpine.store('xQuickView').show = false;
                  }
                  Alpine.store('xPopup').close();

                  const isBundleAdd = (quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'));
                  if (isBundleAdd) {
                    document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                  } else {
                    if (Alpine.store('xMiniCart')) {
                      Alpine.store('xMiniCart').loading = true;
                    }
                    if (useFastMiniCartAdd && Alpine.store('xMiniCart')) {
                      const reloadResult = Alpine.store('xMiniCart').reLoad(['cart-drawer', 'cart-icon-bubble', 'mobile-cart-icon-bubble']);
                      if (reloadResult && typeof reloadResult.then === 'function') {
                        reloadResult.then(() => {
                          if (!Alpine.store('xMiniCart').open) {
                            Alpine.store('xMiniCart').openCart();
                          }
                        }).catch(() => {
                          if (Alpine.store('xMiniCart')) Alpine.store('xMiniCart').loading = false;
                        });
                      } else if (!Alpine.store('xMiniCart').open) {
                        Alpine.store('xMiniCart').openCart();
                      }
                    } else {
                      allSectionsToRender.forEach((section => {
                        const sectionElement = document.querySelector(section.selector);
                        if (sectionElement) {
                          if (response.sections && response.sections[section.id])
                            sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
                        }
                      }));
                      requestAnimationFrame(() => {
                        if (Alpine.store('xMiniCart')) {
                          Alpine.store('xMiniCart').loading = false;
                        }
                      });
                      if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                        Alpine.store('xMiniCart').openCart();
                      }
                    }
                    if (Alpine.store('xQuickView')) {
                      Alpine.store('xQuickView').openPopupMobile = false;
                    }
                    this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                    this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();

                    Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
                  }

                  addAdditionalItemsInBackground(additionalOptionData, allSectionsToRender);
                } else {
                  document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                  this.error_message_wrapper = {};
        
                  if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                    Alpine.store('xQuickView').show = false;
                  }
                  Alpine.store('xPopup').close();
                  
                  if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                    document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                  } else {
                    if (Alpine.store('xMiniCart')) {
                      Alpine.store('xMiniCart').loading = true;
                    }
                    if (useFastMiniCartAdd && Alpine.store('xMiniCart')) {
                      const reloadResult = Alpine.store('xMiniCart').reLoad(['cart-drawer', 'cart-icon-bubble', 'mobile-cart-icon-bubble']);
                      if (reloadResult && typeof reloadResult.then === 'function') {
                        reloadResult.then(() => {
                          if (!Alpine.store('xMiniCart').open) {
                            Alpine.store('xMiniCart').openCart();
                          }
                        }).catch(() => {
                          if (Alpine.store('xMiniCart')) Alpine.store('xMiniCart').loading = false;
                        });
                      } else if (!Alpine.store('xMiniCart').open) {
                        Alpine.store('xMiniCart').openCart();
                      }
                    } else {
                      allSectionsToRender.forEach((section => {
                        const sectionElement = document.querySelector(section.selector);
                        if (sectionElement) {
                          if (response.sections && response.sections[section.id])
                            sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
                        }
                      }));
                      requestAnimationFrame(() => {
                        if (Alpine.store('xMiniCart')) {
                          Alpine.store('xMiniCart').loading = false;
                        }
                      });
                      if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                        Alpine.store('xMiniCart').openCart();
                      }
                    }
                    Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
                    if (Alpine.store('xQuickView')) {
                      Alpine.store('xQuickView').openPopupMobile = false;
                    }
                    this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                    this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();
                    if (Alpine.store('xCartHelper').requestSuppressManagedFreeGiftSyncOnce) {
                      Alpine.store('xCartHelper').requestSuppressManagedFreeGiftSyncOnce();
                    }
                    document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                    if (hasAnyOptionalAtcFeature) {
                      addAdditionalItemsInBackground({
                        items: [],
                        sections: allSectionsToRender.map((section) => section.id)
                      }, allSectionsToRender);
                    }
                  }
                }
              }
            }).catch((error) => {
              console.error('Error:', error);
            }).finally(() => {
              if (window.Eurus && window.Eurus.enableEstimateShipping) {
                Alpine.store('xCartHelper').updateEstimateShippingFull();
              } else {
                window.updatingEstimate = false;
              }
              this.loading = false;
              if ((quickView && Alpine.store('xQuickView').buttonQuickView && !Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && !this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
                if(this.$refs.gift_wrapping_id) this.$refs.gift_wrapping_id.value = '';
              }
              if (insuranceFeatureEnabled) {
                document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/`;
              }
            })
          }, 0)
        }
      }))
    });
  });
}
